import Vue from 'vue';
import state from '../state';

export default {
  async loadAll() {
    const timezones = (await Vue.http.get('/api/timezones')).data;
    state.timezones.set(timezones);
  }
}



// WEBPACK FOOTER //
// ./src/services/timezone.service.js